import { z } from 'zod';
import { OrderBundleDtoSchema } from '../bundles/bundles.schema';
import { PaymentMethod, PaymentTransactionDtoSchema } from '../paymentTransaction/paymentTransaction.schema';
import { FiatCurrencySchema } from '../types/FiatCurrency.types';

// Bundle DTO Schema
export const OrderDtoSchema = z.object({
  id: z.string().uuid(),
  redirectUrl: z.string().url().optional(),
  bundle: OrderBundleDtoSchema,
  state: z.enum(['pending', 'failed', 'success']),
  transaction: PaymentTransactionDtoSchema,
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const CreateOrderSchema = z.object({
  returnUrl: z.string(),
  // bundleId: z.string().uuid(), // Market said it's still used on ULU; this key is outdated here.
  userBundleOfferId: z.string().uuid(),
  currencyType: z.enum(['fiat', 'crypto']),
  // Only set for CashApp deposits; card/crypto are distinguished by currencyType/details instead.
  paymentMethodType: z.nativeEnum(PaymentMethod).optional(),
  details: z.object({
    currency: z.string(),
    network: z.string(),
  }).optional(),
});

export const DepositLimitPeriodSchema = z.enum(['P1D', 'P7D', 'P30D']);

export const DepositLimitSchema = z.object({
  amount: z.number(),
  currency: FiatCurrencySchema,
  period: DepositLimitPeriodSchema,
});

export const UpdateDepositLimitSchema = z.object({
  amount: z.number(),
  currency: FiatCurrencySchema,
});

export const DepositLimitDtoSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  amount: z.number(),
  currency: FiatCurrencySchema,
  period: DepositLimitPeriodSchema,
  spentAmount: z.number(),
  startsAt: z.string().datetime(),
  endsAt: z.string().datetime(),
  updateAmount: z.number().nullable(),
  updateAt: z.object({
    date: z.string().datetime(),
    time: z.string().datetime(),
  }).nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type DepositLimitDto = z.infer<typeof DepositLimitDtoSchema>;
export type DepositLimitPeriod = z.infer<typeof DepositLimitPeriodSchema>;
export type CreateOrderDto = z.infer<typeof CreateOrderSchema>;
export type OrderDto = z.infer<typeof OrderDtoSchema>;
export type CreateDepositLimitPayload = z.infer<typeof DepositLimitSchema>;
export type UpdateDepositLimitPayload = z.infer<typeof UpdateDepositLimitSchema>;
